<script>
import { Bar } from "vue-chartjs";
import "@/plugins/chart";

export default {
    name: "GroupedBarChart",
    extends: Bar,
    props: {
        labels: {
            type: Array,
            default: () => [],
        },
        datasets: {
            type: Array,
            default: () => [],
        },
        valueFormatter: {
            type: Function,
            default: null,
        },
    },
    computed: {
        data(vm = this) {
            return {
                labels: vm.labels,
                datasets: vm.datasets.map(dataset => ({
                    barPercentage: 0.7,
                    categoryPercentage: 0.7,
                    ...dataset,
                })),
            }
        },
        options(vm = this) {
            const theme = vm.$vuetify.theme.currentTheme
            const format = value => (vm.valueFormatter ? vm.valueFormatter(value) : value)
            return {
                responsive: true,
                maintainAspectRatio: false,
                legend: { display: false },
                scales: {
                    xAxes: [{
                        gridLines: { display: false, color: theme.outline },
                        ticks: {
                            fontColor: theme.txtMuted,
                            fontFamily: '"Outfit", sans-serif',
                            fontSize: 10,
                            fontStyle: 'bold',
                        },
                    }],
                    yAxes: [{
                        gridLines: { color: theme.outline, drawBorder: false, zeroLineColor: theme.outline },
                        ticks: {
                            beginAtZero: true,
                            maxTicksLimit: 5,
                            fontColor: theme.txtMuted,
                            fontFamily: '"Outfit", sans-serif',
                            fontSize: 10,
                            callback: value => format(value),
                        },
                    }],
                },
                tooltips: {
                    mode: 'index',
                    intersect: false,
                    backgroundColor: theme.surface2,
                    titleFontColor: theme.txtPrimary,
                    bodyFontColor: theme.txtSecondary,
                    borderColor: theme.outline,
                    borderWidth: 1,
                    cornerRadius: 8,
                    xPadding: 10,
                    yPadding: 8,
                    titleFontFamily: '"Outfit", sans-serif',
                    bodyFontFamily: '"Outfit", sans-serif',
                    callbacks: {
                        label: (tooltipItem, data) => {
                            const dataset = data.datasets[tooltipItem.datasetIndex] || {}
                            const value = format(tooltipItem.yLabel)
                            return dataset.label ? `${dataset.label}: ${value}` : `${value}`
                        },
                    },
                },
            }
        },
    },
    data() {
        return {
            renderKey: null,
        }
    },
    mounted() {
        this.draw()
    },
    methods: {
        draw() {
            const vm = this
            const key = JSON.stringify({
                labels: vm.labels,
                data: vm.datasets.map(dataset => dataset.data),
                colors: vm.datasets.map(dataset => dataset.backgroundColor),
                dark: vm.$vuetify.theme.dark,
            })
            if (key === vm.renderKey) return
            vm.renderKey = key
            vm.renderChart(vm.data, vm.options)
        },
    },
    watch: {
        data() {
            this.draw()
        },
        options() {
            this.draw()
        },
    },
}
</script>
